export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const PRODUCTS_CATEGORIES = {
	DRINK: 'DRINK',
	TAKE_OUT: 'TAKE_OUT',
	FOOD_CONTAINER: 'FOOD_CONTAINER'
};

export const PRODUCTS_BANNERS = {
  DRINK: 'https://ywcnp.com/images/banner/banner_1.png',
  TAKE_OUT: 'https://ywcnp.com/images/banner/banner_2.png',
  FOOD_CONTAINER: 'https://ywcnp.com/images/banner/banner_3.png',
};